/**
 * i18n.js
 * Minimal i18n setup for React 19 migration
 */

export const translationMessages = {};
